/**
 * Checks if a user has access to a specific feature based on their current plan.
 * @param {Object} user - The user object containing plan details.
 * @param {string} keyword - The keyword to search for in the plan features list.
 * @returns {boolean} - True if the user has access, false otherwise.
 */
export const hasFeature = (user, keyword) => {
  if (!user) return false;
  if (user.role === 'admin') return true;
  if (!user.plan || !user.plan.features) return false;

  return user.plan.features.some(feature =>
    feature.toLowerCase().includes(keyword.toLowerCase())
  );
};
